import type { FC } from 'react';
import { useIntl } from 'react-intl';

import { IconArrowLeft } from '@xing-com/icons';

import { MANAGE_USERS_PERMISSION } from '../../config/constants';
import { useTeampermissionsUserResources } from '../../hooks/use-teampermissions-user-resources';
import { EXTERNAL_LINKS } from '../../routes';
import { trackingParams } from '../../utils/tracking';
import BaseButton from '../base-button';
import * as Styled from './logged-in-page.styles';

type LoggedInHeaderProps = {
  isBrandManagerEditor: boolean;
  showBackToCompanies: boolean;
};
export const LoggedInHeader: FC<LoggedInHeaderProps> = ({
  isBrandManagerEditor,
  showBackToCompanies,
}) => {
  const { formatMessage } = useIntl();

  const { data: teampermissionsData, loading: tpLoading } =
    useTeampermissionsUserResources({
      permissions: MANAGE_USERS_PERMISSION,
    });

  if (tpLoading) return null;

  const teampermissionsLength =
    teampermissionsData?.viewer?.teamPermissions?.userResources?.collection
      ?.length;

  const showTeampermissionsButton =
    teampermissionsLength && teampermissionsLength > 0;

  return (
    <>
      <Styled.ButtonsContainer
        data-testid="logged-in-header"
        className={showBackToCompanies ? 'backToCompanies' : undefined}
      >
        {showBackToCompanies ? (
          <BaseButton to={'/companies'} icon={IconArrowLeft} size="small">
            {formatMessage({ id: 'SE_LABEL_COMPANIES' })}
          </BaseButton>
        ) : null}
        <Styled.ButtonsContainer>
          {showTeampermissionsButton ? (
            <Styled.BaseButton
              size="small"
              variant="secondary"
              href={EXTERNAL_LINKS.teampermissions()}
              trackingAttributes={trackingParams.teampermissions}
            >
              {formatMessage({ id: 'CP_TEAMPERMISSIONS' })}
            </Styled.BaseButton>
          ) : null}
          {isBrandManagerEditor ? (
            <Styled.BaseButton
              size="small"
              variant="secondary"
              href={EXTERNAL_LINKS.brandmanager()}
              trackingAttributes={trackingParams.brandmanager}
            >
              {formatMessage({ id: 'CP_BRANDMANAGER' })}
            </Styled.BaseButton>
          ) : null}
          <Styled.BaseButton
            className={'createProfileButton'}
            size="small"
            variant="primary"
            href={EXTERNAL_LINKS.newCompany}
            trackingAttributes={trackingParams.createProfile}
          >
            {formatMessage({ id: 'CP_CREATE_FREE_PROFILE' })}
          </Styled.BaseButton>
        </Styled.ButtonsContainer>
      </Styled.ButtonsContainer>
    </>
  );
};
